module.exports = __webpack_public_path__ + "img/icon_header_login_w.34aaf8fd.svg";